var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 10.0833V6.41666C6.41667 5.20109 6.89955 4.0353 7.75909 3.17576C8.61864 2.31621 9.78442 1.83333 11 1.83333C12.2156 1.83333 13.3814 2.31621 14.2409 3.17576C15.1004 4.0353 15.5833 5.20109 15.5833 6.41666V10.0833M4.58333 10.0833H17.4167C18.4292 10.0833 19.25 10.9041 19.25 11.9167V18.3333C19.25 19.3458 18.4292 20.1667 17.4167 20.1667H4.58333C3.57081 20.1667 2.75 19.3458 2.75 18.3333V11.9167C2.75 10.9041 3.57081 10.0833 4.58333 10.0833Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrivacyPolicy);
export default __webpack_public_path__ + "static/media/icon-privacy-policy.70c12d7fcb64778566828782f506d329.svg";
export { ForwardRef as ReactComponent };